// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8033":"e9d0e23d222663dd","8323":"0e785b558a2c0b64"}[chunkId] + ".css";
};